import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class EnFooter extends Component {
    render() {
        return (
            <div >
                <a href='' onClick={onUnsubClick} target="_blank">Unsubscribe</a>
            </div>
        );
    }
}

export default EnFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/enfooter.js